webpackJsonp([2],{

/***/ 183:
/***/ (function(module, exports) {

module.exports = {"ronda-1":"Ronda 1","ronda-2":"Ronda 2","ronda-3":"Ronda 3","instrucciones":"Instrucciones"}

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.85a12e985c5273deb4db.js